// extracted by mini-css-extract-plugin
module.exports = {"darkMode":"_c3f6b37"};